// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"308":"23e3ed3c","324":"948d62e2","560":"4eb0b984"}[chunkId] + ".css";
};